import { usePostHttp } from "../../../http.hook";
import { IPayoutMethod } from "./approve-payout.admin.http";

export interface IPostPayoutActionResponse {
  payoutMethod: IPayoutMethod;
}

interface IBody {
  message: string;
}

export function useRejectPayoutAdminHttp() {
  return usePostHttp<IBody, IPostPayoutActionResponse>({
    path: "/admin/kyc/creator/payout/:payoutMethodId/reject",
  });
}
